import axios from "../utils/axios.wrapper";

export const getCompanies = async () => {
  const { data } = await axios.get("/company");
  return data?.items ?? [];
};

export const getActiveCompany = async () => {
  const { data } = await axios.get("/company/active");
  return data?.items?.[0];
};

export const getCompanyById = async (id) => {
  const { data } = await axios.get(`/company/${id}`);
  return data;
};

export const createCompany = async (company) => {
  const { data } = await axios.post("/company/create", company); // was "/company"
  return data;
};

export const updateCompany = async (id, company) => {
  const { data } = await axios.put(`/company/${id}`, company);
  return data;
};

export const deleteCompany = async (id) => {
  const { data } = await axios.delete(`/company/${id}`);
  return data;
};

export const configureCompanyPoints = async (id, points) => {
  const { data } = await axios.post(`/company/${id}/configure-points`, {
    points,
  });
  return data;
};
export const activateCompany = async (id) => {
  await axios.put(`/company/${id}/activate`);
  return id;
};

export const deactivateCompany = async (id) => {
  await axios.put(`/company/${id}/deactivate`);
  return id;
};

export const validateCompany = async (id) => {
  const { data } = await axios.put(`/company/${id}/validate`);
  return data;
};

export const companyService = {
  getCompanies,
  getCompanyById,
  getActiveCompany,
  createCompany,
  updateCompany,
  deleteCompany,
  configureCompanyPoints,
  activateCompany,
  deactivateCompany,
  validateCompany,
};
